// src/axiosInstance.jsx
import axios from 'axios';

function base64Decode(base64) {
    // Decode base64 to string
    const binaryString = window.atob(base64);
    try {
        // Try to parse as JSON
        return JSON.parse(binaryString);
    } catch {
        // Fallback: return as string
        return binaryString;
    }
}

const axiosInstance = axios.create({
    baseURL: 'https://promopilotapi.line51.in',
    // baseURL : "http://localhost:8000",
    responseType: 'text', // Expect base64 string
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.response.use(response => {
    try {
        response.data = base64Decode(response.data);
    } catch (error) {
        console.error('Base64 decode failed:', error);
    }
    return response;
}, error => {
    return Promise.reject(error);
});

export { axiosInstance };
